"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  /**
   * 获取链接参数
   * @param url 链接
   * @param name 参数名称
   */
  getUrlParameter: function getUrlParameter(url, name) {
    var regexSearch = '[\\?&#]' + name + '=([^&#]*)';
    var regex = new RegExp(regexSearch);
    var results = regex.exec(url);
    return results ? window.decodeURIComponent(results[1]) : '';
  }
};
exports.default = _default;